import { Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useStockLoss } from './ContextAPI';

export default function ShowModel() {
    const { showModal, setShowModal, rowData } = useStockLoss();
    // Closing the Model
    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <Modal className="modalWidth55" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Facility Stock Loss Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Row>
                            <Col>
                                <Table bordered hover size="sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Partner Name</th>
                                            <th>Facility Name</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{rowData?.partner_name}</td>
                                            <td>{rowData?.facility_name}</td>
                                            <td>{rowData?.date}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table bordered hover size="sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Batch No</th>
                                            <th>Loss Qty</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    {rowData?.loss_items?.map((el) => (
                                        <tbody key={Math.random()}>
                                            <tr>
                                                <td>{el.drug_name}</td>
                                                <td>{el.batch_no}</td>
                                                <td>{el.loss_qty}</td>
                                                <td>{el.loss_remark}</td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </Table>
                            </Col>
                        </Row>
                    </Form.Group>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
